<template>
  <div class="menu-wrap">

    <el-row :gutter="20">
      <el-col :span="5" class="logo">
        <img src="../../assets/logo.png" alt="">
      </el-col>
      <el-col :span="12" class="headermenu">
        <div v-for="val in menuInfo" :key="val.id" @click="goPage(val.url)" class="menu-li"
          :class="activeStatus == val.url ? 'menuActive' : ''">{{ val.name }}</div>
      </el-col>
      <el-col :span="7" class="hedersetting">
        <div class="btn buy" @click="procurement">我要采购</div>
        <div class="btn sell">我要供货</div>
        <!-- <el-popover popper-class="custom-popover-class" placement="top" width="200" trigger="click">
            <div class="login-type">
              <div class="btn buy">我要采购</div>
              <div class="btn sell">我要供货</div>
            </div>
            <div slot="reference" class="btn-login">登录</div>
          </el-popover> -->
      </el-col>
    </el-row>



  </div>
</template>

<script>
export default {
  data() {
    return {
      activeStatus: '',
      menuInfo: [
        { id: 1, name: '首页', url: '/' },
        { id: 2, name: '产品服务', url: '' },
        { id: 3, name: '解决方案', url: '' },
        { id: 4, name: '合作入住', url: '' },
        { id: 5, name: '开放平台API', url: '' },
        { id: 6, name: '关于我们', url: '' },
      ],
      visible: false,
    }
  },
  created() {
    this.activeStatus = window.location.pathname
  },
  methods: {
    goPage(url) {
      if (!url) return;
      this.activeStatus = url
      this.$router.push(url)
    },
    procurement() {
      window.open('https://mancmss.birdicloud.com/#/index', '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
@primary-color: #2376e3;

.menu-wrap {
  position: fixed;
  top: 0;
  width: 100vw;
  // padding: 2px ;
  box-sizing: border-box;
  // display: flex;
  // align-items: center;
  // justify-content: space-around;
  z-index: 99;
  background: #ffffff;
  .el-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .logo {
    text-align: right;

    .name {
      font-size: 16px;
      color: @primary-color;
    }
  }

  .headermenu {
    height: 100%;
    display: flex;

    .menu-li {
      font-size: 18px;
      margin-right: 5%;
    }

    .menuActive {
      color: @primary-color;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .hedersetting {
    display: flex;

    .btn {
      width: 100px;
      padding: 5px 0;
      border-radius: 30px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
    }

    .buy {
      background-color: #7bb2f9;
    }

    .sell {
      margin-left: 20px;
      background-color: #fcca27;
    }

    /deep/ .custom-popover-class {
      /deep/ .login-type {
        display: flex;
        color: #f1642c;

        .btn {
          width: 200px;
          padding: 10px 0;
          border-radius: 30px;
          border: 1px solid #5cb3d2;
        }
      }
    }

    .btn-login {
      padding: 5px 20px;
      box-sizing: border-box;
      background-color: @primary-color;
      color: #fff;
      border-radius: 30px;
      font-size: 14px;
    }
  }
}
</style>
<style lang="less">
/deep/ .custom-popover-class {
  /deep/ .login-type {
    display: flex;
    color: #f1642c;

    .btn {
      width: 200px;
      padding: 10px 0;
      border-radius: 30px;
      border: 1px solid #5cb3d2;
      color: #f1642c;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue